export * from './erAreaBeds.service';